import styled from 'styled-components';
import { OffersListStyled } from '../OffersListStyled';
import { rem } from 'polished';

export const OffersListStyledAP = styled(OffersListStyled)`
    .offer-list-title {
        font-size: ${rem('18px')};
    }
`;
